import { useEffect, useState } from "react";
import { useParams } from 'react-router';
import { containerMiddlewareAdEPortoEnergy } from "../../../../server/constants.api";
import useFetch from "../../../../server/useFetch";
import { useTranslation } from "react-i18next";
import { Row, Col, Flex } from 'antd';
import { NewWidget } from "../../Atomics/NewWidget";
import { alignKeys } from "../../../../utils/hooks/alignKeys";
import { convertTimestampToDayAndMonth } from "../../../../utils/hooks/convertTimestamp";

export const ConsumptionVSProduction = ({ dataToFilter }) => {
  const { t } = useTranslation();
  const { id } = useParams();

  const {
    data: consumptionVSProduction,
    isFetching: consumptionVSProductionIsFetching,
    refetch: refetchConsumptionVSProduction,
  } = useFetch(
    "analytics/monthly/daily/power",
    "getDetailConsumptionVSProductionDeloitte",
    {
      id: id,
      //Traded because we need the last 31 days
      startDate: dataToFilter?.previousPeriod?.toISOString()?.split('.')[0],
      endDate: dataToFilter?.startDay?.toISOString()?.split('.')[0],
    }, null, null, containerMiddlewareAdEPortoEnergy
  );

  useEffect(() => {
    refetchConsumptionVSProduction();
  }, [dataToFilter]);

  return (
    <Flex id='Timeline Load Diagrams' className='ant-anchors-content-item' gap={32} vertical="true">
      <Row gutter={[16, 16]}>
        <Col span={4}>

          <Flex gap={16} vertical="true">
            <NewWidget data={{
              background: 'white',
              title: t('productionPeak'),
              charts: [{
                height: '105px',
                chartType: 'bigNumberChart',
                chartId: 'bigNumberChartOne',
                isFetching: consumptionVSProductionIsFetching,
                data: consumptionVSProduction?.data?.productionPeak?.number ? getBigNumber(consumptionVSProduction?.data?.productionPeak) : null
              }]
            }} />
            <NewWidget data={{
              background: 'white',
              title: t('energyProduced'),
              charts: [{
                height: '105px',
                chartType: 'bigNumberChart',
                chartId: 'bigNumberChartOne',
                isFetching: consumptionVSProductionIsFetching,
                data: consumptionVSProduction?.data?.energyProduced?.number ? getBigNumber(consumptionVSProduction?.data?.energyProduced) : null
              }]
            }} />
          </Flex>
        </Col>
        <Col span={4}>
          <Flex gap={16} vertical="true">
            <NewWidget data={{
              background: 'white',
              title: t('emissionsAvoided'),
              charts: [{
                height: '105px',
                chartType: 'bigNumberChart',
                chartId: 'bigNumberChartOne',
                isFetching: consumptionVSProductionIsFetching,
                data: consumptionVSProduction?.data?.emissionsAvoided?.number ? getBigNumber(consumptionVSProduction?.data?.emissionsAvoided) : null
              }]
            }} />
            <NewWidget data={{
              background: 'white',
              title: t('gridInjection'),
              charts: [{
                height: '105px',
                chartType: 'bigNumberChart',
                chartId: 'bigNumberChartOne',
                isFetching: consumptionVSProductionIsFetching,
                data: consumptionVSProduction?.data?.gridInjection?.number ? getBigNumber(consumptionVSProduction?.data?.gridInjection) : null
              }]
            }} />
          </Flex>
        </Col>
        <Col span={16}>
          <NewWidget data={{
            background: 'white',
            title: t('energy'),
            charts: [{
              height: '287px',
              chartType: 'mixedLineColumnChartApex',
              chartId: 'mixBarChartLineThree',
              isFetching: consumptionVSProductionIsFetching,
              data: consumptionVSProduction?.data?.consumptionData && consumptionVSProduction?.data?.productionData ? getEnergyVSConsumed(consumptionVSProduction?.data, t) : null
            }]
          }} />
        </Col>

      </Row>
    </Flex >
  )
};

const getBigNumber = (data) => {
  return { number: data?.number, unit: data?.unit, icon: 'Bolt' }
};

const getEnergyVSConsumed = (data, t) => {
  const consumedData = convertTimestampToDayAndMonth(data?.consumptionData?.data);
  const producedData = convertTimestampToDayAndMonth(data?.productionData?.data);
  
  const { result, keys } = alignKeys('dd/mm', { 'Consumed': consumedData }, { 'Produced': producedData });
  // Criação do array 'series' somente com os objetos que contêm dados
  const series = [];

  result?.map((item, index) => {
    const values = Object.values(item)[0];
    const data = Object.entries(values)?.map(([key, value]) => { return value });

    series.push({
      name: t(Object.keys(item)[0]),//TODO: Add Translations
      data: data
    })
  });

  return {
    "series": series,
    "categories": [],
    "labels": keys,
    "xAxisType": null,
    // "labelFormat": "Monthly", //talves diario faz mais sentido ou horario
    "tooltip": null,
    "unit": "kWh",
    "columnWidth": 20,
    "xAxisLabel": null,
    "yAxisLabel": "kWh",
    yAxisLabelRotate: -90,
    "color": null,
    tickAmount: 12,
    // "formatterType": "Monthly", //talves diario faz mais sentido ou horario
    "filename": "Gráfico exportado",
    "headerValue": "valores",
    "headerCategory": "categorias",
    "showTooltipTitle": true
  };
};